

// // src/components/AddAdminDrawer.jsx
// import { useState } from "react";
// import axios from "axios";

// export default function AddAdminDrawer({ isOpen, onClose, refreshAdmins }) {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     organization_name: "",
//     organization_code: "",
//     address: "",
//     business_category: "",
//   });

//   const [error, setError] = useState("");
//   const [fieldErrors, setFieldErrors] = useState({});

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setFieldErrors({});

//     const errors = {};
//     if (!form.name.trim()) errors.name = "Name is required";
//     if (!form.email.includes("@") || !form.email.includes(".")) errors.email = "Valid email required";
//     if (!form.phone.trim() || form.phone.length < 10) errors.phone = "Valid phone required";
//     if (!form.organization_name.trim()) errors.organization_name = "Required";
//     if (!form.organization_code.trim()) errors.organization_code = "Required";

//     if (Object.keys(errors).length > 0) {
//       setFieldErrors(errors);
//       return;
//     }

//     try {
//       await axios.post("http://127.0.0.1:8000/api/superadmins/", form, {
//         headers: { "Content-Type": "application/json" },
//       });

//       refreshAdmins();
//       onClose();
//       setForm({
//         name: "", email: "", phone: "", organization_name: "", organization_code: "", address: "", business_category: "",
//       });
//     } catch (err) {
//       const serverError = err.response?.data;
//       if (serverError && typeof serverError === "object") {
//         setFieldErrors(serverError);
//         setError("Please correct the highlighted fields");
//       } else {
//         setError("Something went wrong. Please try again.");
//       }
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//     if (fieldErrors[name]) {
//       setFieldErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   return (
//     <>
//       {isOpen && (
//         <div
//           className="fixed inset-0 bg-black/70 dark:bg-black/80 backdrop-blur-sm z-50 transition-opacity duration-300"
//           onClick={onClose}
//         />
//       )}

//       <div
//         className={`
//           fixed top-0 right-0 h-full w-full max-w-[520px] 
//           shadow-2xl z-50 transform transition-transform duration-300 ease-out
//           border-l border-card-border dark:border-card-border
//           bg-card-bg dark:bg-card-bg
//           ${isOpen ? "translate-x-0" : "translate-x-full"}
//         `}
//       >
//         {/* Header */}
//         <div className="
//           px-8 md:px-10 py-6 border-b 
//           bg-secondary-bg dark:bg-secondary-bg
//           border-card-border dark:border-card-border
//         ">
//           <div className="flex justify-between items-center">
//             <div>
//               <h2 className="text-2xl md:text-3xl font-bold text-primary-text dark:text-primary-text">
//                 Create Super Admin
//               </h2>
//               <p className="text-secondary-text dark:text-secondary-text mt-1 text-sm md:text-base">
//                 Add new elevated access account
//               </p>
//             </div>
//             <button
//               onClick={onClose}
//               className="
//                 text-secondary-text hover:text-accent-orange-500 
//                 dark:text-secondary-text dark:hover:text-accent-orange-400 
//                 text-3xl md:text-4xl transition-colors duration-200
//               "
//             >
//               ×
//             </button>
//           </div>
//         </div>

//         {/* Form */}
//         <form 
//           className="p-6 md:p-10 space-y-6 md:space-y-8 overflow-y-auto h-[calc(100vh-140px)]"
//           onSubmit={handleSubmit}
//         >
//           {error && (
//             <div className="
//               bg-loss-red/10 dark:bg-loss-red/20 
//               border border-loss-red/40 dark:border-loss-red/30 
//               text-loss-red px-4 py-3 rounded-xl text-sm
//             ">
//               {error}
//             </div>
//           )}

//           {/* Input fields */}
//           {[
//             { name: "name", label: "Full Name", type: "text" },
//             { name: "email", label: "Email Address", type: "email" },
//             { name: "phone", label: "Phone Number", type: "tel" },
//             { name: "organization_name", label: "Organization Name" },
//             { name: "organization_code", label: "Organization Code" },
//             { name: "business_category", label: "Business Category" },
//             {
//               name: "super_admin_code",
//               label: "Super Admin Code",
//               placeholder: "Auto-generated on save",
//               readOnly: true,
//             },
//           ].map((field) => (
//             <div key={field.name} className="relative">
//               <input
//                 type={field.type || "text"}
//                 name={field.name}
//                 id={field.name}
//                 value={form[field.name] || ""}
//                 onChange={handleChange}
//                 readOnly={field.readOnly}
//                 placeholder={field.placeholder || " "}
//                 className={`
//                   peer w-full px-5 pt-7 pb-2 rounded-xl outline-none transition-all duration-200
//                   border border-card-border dark:border-card-border
//                   bg-secondary-bg dark:bg-secondary-bg
//                   text-primary-text dark:text-primary-text
//                   placeholder:text-secondary-text dark:placeholder:text-secondary-text
//                   ${field.readOnly 
//                     ? "cursor-not-allowed text-secondary-text dark:text-secondary-text italic" 
//                     : "focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20"}
//                   ${fieldErrors[field.name] ? "!border-loss-red focus:!border-loss-red" : ""}
//                 `}
//               />
//               <label
//                 htmlFor={field.name}
//                 className={`
//                   absolute left-5 pointer-events-none transition-all duration-200 text-sm
//                   ${form[field.name] 
//                     ? "text-xs top-2 text-accent-orange-500 dark:text-accent-orange-400 font-medium" 
//                     : "top-5 text-secondary-text dark:text-secondary-text"}
//                 `}
//               >
//                 {field.label}
//               </label>
//               {fieldErrors[field.name] && (
//                 <p className="text-loss-red dark:text-loss-red text-xs mt-1.5 ml-1">
//                   {fieldErrors[field.name]}
//                 </p>
//               )}
//             </div>
//           ))}

//           {/* Address textarea */}
//           <div className="relative">
//             <textarea
//               name="address"
//               id="address"
//               value={form.address}
//               onChange={handleChange}
//               rows={4}
//               className="
//                 peer w-full px-5 pt-7 pb-2 rounded-xl outline-none transition-all duration-200
//                 border border-card-border dark:border-card-border
//                 bg-secondary-bg dark:bg-secondary-bg
//                 text-primary-text dark:text-primary-text
//                 placeholder:text-secondary-text dark:placeholder:text-secondary-text
//                 focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                 resize-none
//               "
//               placeholder=" "
//             />
//             <label
//               htmlFor="address"
//               className={`
//                 absolute left-5 pointer-events-none transition-all duration-200 text-sm
//                 ${form.address 
//                   ? "text-xs top-2 text-accent-orange-500 dark:text-accent-orange-400 font-medium" 
//                   : "top-5 text-secondary-text dark:text-secondary-text"}
//               `}
//             >
//               Full Address
//             </label>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             className="
//               w-full py-4 mt-6 
//               bg-gradient-to-r from-accent-orange-600 to-accent-orange-700 
//               hover:from-accent-orange-700 hover:to-accent-orange-800 
//               text-white font-semibold rounded-xl shadow-lg hover:shadow-xl 
//               transition-all duration-200 active:scale-[0.98] 
//               flex items-center justify-center gap-2
//             "
//           >
//             Create Super Admin Account
//           </button>
//         </form>
//       </div>
//     </>
//   );
// }

// // src/components/AddAdminDrawer.jsx
// import { useState } from "react";
// import axios from "axios";

// export default function AddAdminDrawer({ isOpen, onClose, refreshAdmins }) {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     organization_name: "",
//     address: "",
//     business_category: "",
//   });

//   const [error, setError] = useState("");
//   const [fieldErrors, setFieldErrors] = useState({});

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setFieldErrors({});

//     const errors = {};
//     if (!form.name.trim()) errors.name = "Name is required";
//     if (!form.email.includes("@") || !form.email.includes(".")) errors.email = "Valid email required";
//     if (!form.phone.trim() || form.phone.length < 10) errors.phone = "Valid phone required";
//     if (!form.organization_name.trim()) errors.organization_name = "Organization name is required";

//     if (Object.keys(errors).length > 0) {
//       setFieldErrors(errors);
//       return;
//     }

//     try {
//       await axios.post("http://127.0.0.1:8000/api/superadmins/", form, {
//         headers: { "Content-Type": "application/json" },
//       });

//       refreshAdmins();
//       onClose();
//       setForm({
//         name: "",
//         email: "",
//         phone: "",
//         organization_name: "",
//         address: "",
//         business_category: "",
//       });
//     } catch (err) {
//       const serverError = err.response?.data;
//       if (serverError && typeof serverError === "object") {
//         setFieldErrors(serverError);
//         setError("Please correct the highlighted fields");
//       } else {
//         setError("Something went wrong. Please try again.");
//       }
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//     if (fieldErrors[name]) {
//       setFieldErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   return (
//     <>
//       {isOpen && (
//         <div
//           className="fixed inset-0 bg-black/70 dark:bg-black/80 backdrop-blur-sm z-50 transition-opacity duration-300"
//           onClick={onClose}
//         />
//       )}

//       <div
//         className={`
//           fixed top-0 right-0 h-full w-full max-w-[520px] 
//           shadow-2xl z-50 transform transition-transform duration-300 ease-out
//           border-l border-card-border dark:border-card-border
//           bg-card-bg dark:bg-card-bg
//           ${isOpen ? "translate-x-0" : "translate-x-full"}
//         `}
//       >
//         {/* Header */}
//         <div className="
//           px-8 md:px-10 py-6 border-b 
//           bg-secondary-bg dark:bg-secondary-bg
//           border-card-border dark:border-card-border
//         ">
//           <div className="flex justify-between items-center">
//             <div>
//               <h2 className="text-2xl md:text-3xl font-bold text-primary-text dark:text-primary-text">
//                 Create Super Admin
//               </h2>
//               <p className="text-secondary-text dark:text-secondary-text mt-1 text-sm md:text-base">
//                 Add new elevated access account
//               </p>
//             </div>
//             <button
//               onClick={onClose}
//               className="
//                 text-secondary-text hover:text-accent-orange-500 
//                 dark:text-secondary-text dark:hover:text-accent-orange-400 
//                 text-3xl md:text-4xl transition-colors duration-200
//               "
//             >
//               ×
//             </button>
//           </div>
//         </div>

//         {/* Form */}
//         <form 
//           className="p-6 md:p-10 space-y-6 md:space-y-8 overflow-y-auto h-[calc(100vh-140px)]"
//           onSubmit={handleSubmit}
//         >
//           {error && (
//             <div className="
//               bg-loss-red/10 dark:bg-loss-red/20 
//               border border-loss-red/40 dark:border-loss-red/30 
//               text-loss-red px-4 py-3 rounded-xl text-sm
//             ">
//               {error}
//             </div>
//           )}

//           {/* Input fields - removed organization_code & super_admin_code */}
//           {[
//             { name: "name", label: "Full Name", type: "text" },
//             { name: "email", label: "Email Address", type: "email" },
//             { name: "phone", label: "Phone Number", type: "tel" },
//             { name: "organization_name", label: "Organization Name" },
//             { name: "business_category", label: "Business Category" },
//           ].map((field) => (
//             <div key={field.name} className="relative">
//               <input
//                 type={field.type || "text"}
//                 name={field.name}
//                 id={field.name}
//                 value={form[field.name] || ""}
//                 onChange={handleChange}
//                 placeholder=" "
//                 className={`
//                   peer w-full px-5 pt-7 pb-2 rounded-xl outline-none transition-all duration-200
//                   border border-card-border dark:border-card-border
//                   bg-secondary-bg dark:bg-secondary-bg
//                   text-primary-text dark:text-primary-text
//                   placeholder:text-secondary-text dark:placeholder:text-secondary-text
//                   focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                   ${fieldErrors[field.name] ? "!border-loss-red focus:!border-loss-red" : ""}
//                 `}
//               />
//               <label
//                 htmlFor={field.name}
//                 className={`
//                   absolute left-5 pointer-events-none transition-all duration-200 text-sm
//                   ${form[field.name] 
//                     ? "text-xs top-2 text-accent-orange-500 dark:text-accent-orange-400 font-medium" 
//                     : "top-5 text-secondary-text dark:text-secondary-text"}
//                 `}
//               >
//                 {field.label}
//               </label>
//               {fieldErrors[field.name] && (
//                 <p className="text-loss-red dark:text-loss-red text-xs mt-1.5 ml-1">
//                   {fieldErrors[field.name]}
//                 </p>
//               )}
//             </div>
//           ))}

//           {/* Address textarea */}
//           <div className="relative">
//             <textarea
//               name="address"
//               id="address"
//               value={form.address}
//               onChange={handleChange}
//               rows={4}
//               className="
//                 peer w-full px-5 pt-7 pb-2 rounded-xl outline-none transition-all duration-200
//                 border border-card-border dark:border-card-border
//                 bg-secondary-bg dark:bg-secondary-bg
//                 text-primary-text dark:text-primary-text
//                 placeholder:text-secondary-text dark:placeholder:text-secondary-text
//                 focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                 resize-none
//               "
//               placeholder=" "
//             />
//             <label
//               htmlFor="address"
//               className={`
//                 absolute left-5 pointer-events-none transition-all duration-200 text-sm
//                 ${form.address 
//                   ? "text-xs top-2 text-accent-orange-500 dark:text-accent-orange-400 font-medium" 
//                   : "top-5 text-secondary-text dark:text-secondary-text"}
//               `}
//             >
//               Full Address
//             </label>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             className="
//               w-full py-4 mt-8 
//               bg-gradient-to-r from-accent-orange-600 to-accent-orange-700 
//               hover:from-accent-orange-700 hover:to-accent-orange-800 
//               text-white font-semibold rounded-xl shadow-lg hover:shadow-xl 
//               transition-all duration-200 active:scale-[0.98] 
//               flex items-center justify-center gap-2
//             "
//           >
//             Create Super Admin Account
//           </button>
//         </form>
//       </div>
//     </>
//   );
// }

// src/components/AddAdminDrawer.jsx
import { useState } from "react";
import axios from "axios";

export default function AddAdminDrawer({ isOpen, onClose, refreshAdmins }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    organization_name: "",
    address: "",
    business_category: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setFieldErrors({});
    setSuccess(false);

    const errors = {};
    if (!form.name.trim()) errors.name = "Full name is required";
    if (!form.email.includes("@") || !form.email.includes(".")) errors.email = "Valid email required";
    if (!form.phone.trim() || form.phone.length < 10) errors.phone = "Valid phone number required (min 10 digits)";
    if (!form.organization_name.trim()) errors.organization_name = "Organization name is required";

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setLoading(true);

    try {
      await axios.post("http://127.0.0.1:8000/api/superadmins", form, {
        headers: { "Content-Type": "application/json" },
      });

      setSuccess(true);

      // Give user time to see success message
      setTimeout(() => {
        refreshAdmins();
        onClose();
        setForm({
          name: "", email: "", phone: "", organization_name: "", address: "", business_category: ""
        });
      }, 1800);

    } catch (err) {
      const serverError = err.response?.data;
      if (serverError && typeof serverError === "object" && serverError.errors) {
        const formattedErrors = {};
        Object.keys(serverError.errors).forEach(key => {
          formattedErrors[key] = serverError.errors[key][0];
        });
        setFieldErrors(formattedErrors);
        setError("Please correct the highlighted fields");
      } else {
        setError(err.response?.data?.message || "Failed to create super admin. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50"
        onClick={onClose}
      />

      <div className={`
        fixed top-0 right-0 h-full w-full max-w-[520px] z-50
        bg-card-bg border-l border-card-border shadow-2xl
        transform transition-transform duration-300
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}
      `}>
        <div className="px-8 py-6 border-b bg-secondary-bg">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold">Create Super Admin</h2>
              <p className="text-secondary-text mt-1">Add new elevated access account</p>
            </div>
            <button
              onClick={onClose}
              className="text-4xl text-secondary-text hover:text-accent-orange-400"
            >
              ×
            </button>
          </div>
        </div>

        <form className="p-8 space-y-7 overflow-y-auto h-[calc(100vh-140px)]" onSubmit={handleSubmit}>
          {error && (
            <div className="bg-red-500/10 border border-red-500/40 text-red-400 px-4 py-3 rounded-xl">
              {error}
            </div>
          )}

          {success && (
            <div className="bg-green-500/10 border border-green-500/30 text-green-400 px-4 py-3 rounded-xl">
              Super Admin created successfully! Refreshing list...
            </div>
          )}

          {[
            { name: "name", label: "Full Name", type: "text" },
            { name: "email", label: "Email Address", type: "email" },
            { name: "phone", label: "Phone Number", type: "tel" },
            { name: "organization_name", label: "Organization Name", type: "text" },
            { name: "business_category", label: "Business Category", type: "text" },
          ].map((field) => (
            <div key={field.name} className="relative">
              <input
                type={field.type || "text"}
                name={field.name}
                value={form[field.name] || ""}
                onChange={handleChange}
                placeholder=" "
                className={`
                  peer w-full px-5 pt-7 pb-2 rounded-xl border
                  bg-secondary-bg text-primary-text
                  focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
                  ${fieldErrors[field.name] ? 'border-red-500' : 'border-card-border'}
                `}
              />
              <label
                className={`
                  absolute left-5 pointer-events-none transition-all text-sm
                  ${form[field.name] ? 'top-2 text-xs text-accent-orange-500' : 'top-5 text-secondary-text'}
                `}
              >
                {field.label}
              </label>
              {fieldErrors[field.name] && (
                <p className="text-red-400 text-xs mt-1 ml-1">{fieldErrors[field.name]}</p>
              )}
            </div>
          ))}

          <div className="relative">
            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              rows={4}
              placeholder=" "
              className={`
                peer w-full px-5 pt-7 pb-2 rounded-xl border bg-secondary-bg
                focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
                ${fieldErrors.address ? 'border-red-500' : 'border-card-border'}
              `}
            />
            <label
              className={`
                absolute left-5 pointer-events-none transition-all text-sm
                ${form.address ? 'top-2 text-xs text-accent-orange-500' : 'top-5 text-secondary-text'}
              `}
            >
              Full Address
            </label>
          </div>

          <button
            type="submit"
            disabled={loading || success}
            className={`
              w-full py-4 mt-6 rounded-xl font-semibold text-white
              bg-gradient-to-r from-orange-600 to-orange-700
              hover:from-orange-700 hover:to-orange-800
              disabled:opacity-60 disabled:cursor-not-allowed
              shadow-lg transition-all
            `}
          >
            {loading ? 'Creating...' : success ? 'Created!' : 'Create Super Admin Account'}
          </button>
        </form>
      </div>
    </>
  );
}